import { removeLocalStorageItem } from "./localStorage";

export const checkIfLogin = () => {
  const token = JSON.parse(localStorage.getItem("token"));
  return !!token;
};

export const setLocalStorageForLogout = () => {
  removeLocalStorageItem("token");
  removeLocalStorageItem("id");
  removeLocalStorageItem("walletType");
};

export const checkIfCreator = (is_approved_creator) =>
  checkIfLogin() && !!is_approved_creator;

export const checkIfAdmin = (is_admin) => checkIfLogin() && !!is_admin;

export const trimTextContent = (text, limit) => {
  if (text.length <= limit) return text;
  return text.substring(0, limit - 3).concat(" ...");
};

export const getEtherscanLink = (network, txHash) =>
  `https://${network}.etherscan.io/tx/${txHash}`;

export const embedMessageString = (message, embedString = "") => {
  if (message) {
    const regex = new RegExp(/\|___\|/, "g");

    let resultantMessage = message;

    if (Array.isArray(embedString)) {
      const matches = [];
      let result;
      while ((result = regex.exec(message))) {
        matches.push(result);
      }

      matches.forEach((match, index) => {
        if (index < embedString.length) {
          resultantMessage = resultantMessage.replace(
            /\|___\|/,
            embedString[index]
          );
        }
      });
    } else {
      resultantMessage = resultantMessage.replace(regex, embedString);
    }

    return resultantMessage;
  } else {
    return "";
  }
};

export const checkIfCorrectChain = (connectedChainId, correctChainId) => {
  if (typeof correctChainId !== "number") return false;
  else return correctChainId === connectedChainId;
};

export const copyToClipboard = async (text = "", onSuccess, onError) => {
  try {
    await navigator.clipboard.writeText(text);
    onSuccess && onSuccess();
  } catch (error) {
    onError && onError();
  }
};
